export function getLines(text: string): string[] {
    const lines: string[] = [];
     
    const lineBreak = '<br\s*\/?>'
    const lineBreakExp = new RegExp(`(.+)(${lineBreak})(.+)`, 'g')
    let remaining = text;
    while (remaining.match(lineBreakExp)) {
        lines.push(remaining.replace(lineBreakExp, '$1'));
        remaining = remaining.replace(lineBreakExp, '$3');
    }
    lines.push(remaining);
    return lines;
}

export const Empty = '';

export const format = function (str: string, ...parameters: any[]): string {
    return str.replace(/{(\d+)}/g, (match: string, index: number) => parameters[index] != null
        ? parameters[index]
        : match);
};

export const equalsIgnoreCase = function (str: string, other: string): boolean {
    return str.localeCompare(other, undefined, { sensitivity: 'base' }) === 0;
};

export const contains = function (str: string, other: string): boolean {
    if (str && other) {
        return str.toLowerCase().includes(other.toLowerCase());
    } else {
        return false;
    }
};

export const lineBreaks = function (str: string, wordWrap = true): string {
    return str.replace(/--/g, wordWrap ? '-<br/>' : '');
}
